import { render, staticRenderFns } from "./BroadcastScreenLayout.vue?vue&type=template&id=ac9b3480&scoped=true&"
import script from "./BroadcastScreenLayout.vue?vue&type=script&lang=js&"
export * from "./BroadcastScreenLayout.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastScreenLayout.vue?vue&type=style&index=0&id=ac9b3480&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9b3480",
  null
  
)

export default component.exports